import { onSettle } from '@bugsnag/browser-performance';

class VueRouterRoutingProvider {
    constructor(router, basename) {
        this.router = router;
        const normalizedBasename = !basename || basename === '/' ? '' : basename;
        function resolveRoute(url) {
            var _a;
            const location = router.resolve({ path: url.pathname.replace(normalizedBasename !== null && normalizedBasename !== void 0 ? normalizedBasename : '', '') });
            return ((_a = location.matched.pop()) === null || _a === void 0 ? void 0 : _a.path) || 'no-route-found';
        }
        this.resolveRoute = resolveRoute;
    }
    listenForRouteChanges(startRouteChangeSpan) {
        this.router.beforeResolve((to, from) => {
            if (!from.name) {
                // initial load
                return;
            }
            const absoluteURL = new URL(to.path, document.baseURI);
            const span = startRouteChangeSpan(absoluteURL, 'beforeResolve');
            onSettle((endTime) => {
                span.end(endTime);
            });
        });
    }
}

export { VueRouterRoutingProvider };
